import { getParameterByName } from "../../../utils/urlParser";
import { registrationInitialState } from "./register.types";

const returnUrl = getParameterByName("returnUrl");
const passedUsername = decodeURIComponent(getParameterByName("username"));

export const initialState: registrationInitialState = {
	isAccountBlockedAwaitingApproval: false,
	showConditionsModal: false,
	showNewsletterModal: false,
	isRegisteringNewUser: false,
	alerts: [],
	b2c: {
		postcodeValidated: false,
		lastCheckedPostcodeNumber: "",
		isCheckingUsername: false,
		usernameExists: false,
		savedUsername: "",
		form: {
			password: "",
			name: "",
			addressLine1: "",
			postcode: "",
			city: "",
			country: "",
			email: "",
			passedEmail: passedUsername,
			phone: "",
			returnUrl,
			acceptWeeklyNewsletter: false,
			acceptCustomerConditions: false,
			acceptSalesConditions: false,
			acceptEmailNotifications: false,
			acceptSMSNotifications: false,
		},
	},
	b2b: {
		isEditCompanyDataMode: false,
		postcodeValidated: false,
		organisationNumberValidated: false,
		subunitOrganisationNumberValidated: false,
		lastCheckedPostcodeNumber: "",
		lastCheckedOrganisationNumber: "",
		isCheckingUsername: false,
		isSubunitSearchActive: false,
		hasNoResults: false,
		missingSubunitData: false,
		isFetching: false,
		usernameExists: false,
		savedUsername: "",
		form: {
			lookupId: "",
			canonicalId: "",
			companyData: [],
			isFetchingCompanyData: false,
			subunitsCompanyData: [],
			isFetchingSubunits: false,
			companyDetailsNumber: "",
			businessName: "",
			organisationNumber: "",
			subunitName: "",
			subunitOrganisationNumber: "",
			companyAddress: "",
			postcode: "",
			city: "",
			name: "",
			phone: "",
			email: passedUsername,
			invoiceEmail: "",
			password: "",
			isPublic: false,
			acceptCustomerConditions: false,
			acceptSalesConditions: false,
			acceptOffersInformations: false,
			acceptEmailNotifications: false,
			acceptSmsNotifications: false,
			consentsInformationText: null,
			acceptMarketingConsents: false,
			acceptClubAgreementConsents: false,
			accept3rdPartyMarketingConsents: false,
			returnUrl,
		},
	},
	profile: {
		isFetching: false,
		profileDataReady: false,
		form: {
			id: "",
			email: "",
			password: "",
			role: "",
			isClubMember: false,
			acceptClubAgreementConsents: false,
			acceptSmsNotifications: false,
			acceptOffersInformations: false,
			isBusinessConsentsEnabled: false,
			returnUrl,
		},
	},
};
